import {Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {LoggerService} from './logger.service';

@Injectable()
export class TitleService {

    constructor(private browserTitle: Title,
                private logger: LoggerService) {
    }

    setTitle(title: string) {
        this.browserTitle.setTitle(title ? title : 'HBS Poll');
    }

}
